import * as http from './http';

// 消息列表
export const reqMsgList = (params) => http.post('/message/list', params, { interceptRes: true })
// 获取消息详情
export const reqMsgDetail = (params) => http.post('/message/detail', params, { interceptRes: true })
// 清空全部消息
export const reqClearMsgList = (params) => http.post('/message/deleteAll', params)
// 删除消息
export const reqDeleteMsg = (params) => http.post('/message/delete', params)

/* ---个人中心---*/
//多企业绑定、解绑
//绑定企业列表
export const ueryMyCompanyList = () => http.post('/company/info/queryMyCompanyList')
//解绑企业
export const delCompany = (params) => http.post('/company/info/delCompany', params)
//切换企业
export const changeCompany = (params) => http.post('/user/info/changeCompany', params)

// 个人中心页面
export const reqGetMyPageInfo = (params) => http.post('/user/info/myPageInfo', params, { interceptRes: false })
// 意见反馈
export const reqSubmitFeedback = (params) => http.post('/feedback/save', params)
// 获取个人信息
export const reqGetUserInfo = (params) => http.post('/user/info/', params, { interceptRes: false })
// 修改个人信息
export const reqUpdateInfo = (params) => http.post('/user/info/update', params, { interceptRes: false })
// 点赞、收藏、浏览 分页查询
export const reqRecordList = (params) =>  http.post('/user/record/query', params, { interceptRes: true })
// 点赞、收藏、浏览 删除
export const reqDeleteRecord = (params) =>  http.post('/user/record/deleteRecord', params, { interceptRes: true })
// 点赞、收藏、浏览 清空
export const reqClearRecord = (params) =>  http.post('/user/record/deleteAllRecord', params, { interceptRes: true })
// 政策小秘书列表
export const reqSecretaryPolicy = (params) =>  http.post('/policy/secretaryPolicy', params, { interceptRes: false })
// 获取职务列表
export const reqPositonList = () =>  http.post('/dict/positionList', null, { interceptRes: true })
// 个人优惠券
export const reqGetCouponList = (params) => http.post('/coupon/queryUserCouponPage',params, { interceptRes: true,  loading: false })
// 删除个人不可用优惠券
export const reqDeleteCoupon =  (params) => http.post('/coupon/delUserCoupon',params, { interceptRes: true })

//我的订阅区域列表
export const mySubscribe = () => http.post('/policy/subscribe/mySubscribe')
//新增订阅
export const addMySubscribe = (params) => http.post('/policy/subscribe/addMySubscribe',params,{interceptRes:false})
//订阅编辑
export const updateMySubscribe = (params) => http.post('/policy/subscribe/updateMySubscribe',params)
//订阅删除
export const deleteMySubscribe = (params) => http.post('policy/subscribe/deleteMySubscribe',params)
//推荐关键词查询
export const queryKeyword = () => http.post('/keyword/query')
//更新新消息数据
export const deleteNews = (params) => http.post('/policy/subscribe/deleteNews',params)

// 订阅-订阅政策列表
export const reqUnReadPlicy =  (params) => http.post('/policy/unReadPliocy',params, { interceptRes: true })
// 订阅-订阅列表详情
export const reqSubscribeList=  (params) => http.post('/policy/userSubscribeList',params, { interceptRes: true })

